'use client'
import {
  TAG_QUERY
} from "./chunk-MWW3YBFP.mjs";
import {
  LOCATION_QUERY
} from "./chunk-4R6INYD4.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/card.ts
var CARD_QUERY = `
sys { id }
id
title
subtitle
description
buttonLabel
href
image{${IMAGE_QUERY}}
image31{${IMAGE_QUERY}}
image11{${IMAGE_QUERY}}
image23{${IMAGE_QUERY}}
icon{${IMAGE_QUERY}}
background{${IMAGE_QUERY}}
location{${LOCATION_QUERY}}
cmsTagsCollection(limit: 10){
    items {${TAG_QUERY}}
}
color
isNew
frequency
expiresAt
rate
`;

export {
  CARD_QUERY
};
//# sourceMappingURL=chunk-ZJBMFTE6.mjs.map